import { parseMindmapSyntax } from '@/features/mindmap/core/syntax/Parser';
import { printMindmapSyntax } from '@/features/mindmap/core/syntax/Printer';
import { mindmapToSyntaxTree, syntaxTreeToMindmap } from './MindmapTextAdapter';
import type { Mindmap, MindmapNode } from './MindmapTypes';

export function importMindmapFromText(text: string): Mindmap {
  const tree = parseMindmapSyntax(text);
  return syntaxTreeToMindmap(tree);
}

export function exportMindmapToText(mindmap: Mindmap): string {
  const tree = mindmapToSyntaxTree(mindmap);
  return printMindmapSyntax(tree);
}

export function exportMindmapToList(mindmap: Mindmap): string {
  const nodeById = new Map<MindmapNode['id'], MindmapNode>();
  const childrenMap = new Map<MindmapNode['id'] | null, MindmapNode[]>();

  mindmap.nodes.forEach((node) => {
    nodeById.set(node.id, node);
    if (!childrenMap.has(node.parentId)) {
      childrenMap.set(node.parentId, []);
    }
    childrenMap.get(node.parentId)!.push(node);
  });

  for (const list of childrenMap.values()) {
    list.sort((a, b) => a.order - b.order);
  }

  const lines: string[] = [];

  const traverse = (nodeId: string, depth: number) => {
    const node = nodeById.get(nodeId);
    if (!node) return;
    const indent = '  '.repeat(depth);
    lines.push(`${indent}- ${node.text}`);
    const children = childrenMap.get(nodeId) ?? [];
    children.forEach((child) => traverse(child.id, depth + 1));
  };

  const root = nodeById.get(mindmap.rootId);
  if (!root) return '';
  traverse(root.id, 0);
  return lines.join('\n');
}
